/*
 * Wizard control
*/

rs.module("controls/navigation/wizard",

    [
        "common/form-submission"
    ],

    function (formSubmission) {

        // The wizard's navigation token
        var _navigationToken;
        var _onPausingCallback;

        //
        // Initialize
        //
        function initialize(jsSelectors, navigationToken) {

            var wizardSelector = `[data-wizard='${jsSelectors.wizard}']`;
            var wizardDiv = $(wizardSelector);
            var form = wizardDiv.js(jsSelectors.form);
            _navigationToken = navigationToken;

            // Ensure the form is loaded for unubtrusive validation (it may not be yet if it was loaded via ajax).
            $.validator.unobtrusive.parse(form);

            // Handle form submissions
            form.on("submit", function (event) {

                event.preventDefault();

                var ajaxForbiddenError = false;

                // Get the button that was clicked to submit the form
                var clickedButton = $(event.originalEvent.submitter);

                var pauseClicked = clickedButton.data("pause");

                if (pauseClicked && _onPausingCallback) {
                    _onPausingCallback.call(null)
                        .then(function () {
                            completeSubmission();
                        })
                        .catch(function () {
                            formSubmission.onInvalidFormSubmit(event);
                        });
                }
                else {
                    completeSubmission();
                }

                function completeSubmission() {
                    // Does this button require form values (i.e. the Next button)
                    var includeFormValues = clickedButton.attr("formnovalidate") == undefined;

                    // Only navigate if the form is valid (or moving back\cancelling) - test !includeFormValues first for short-circuit purposes
                    if (!includeFormValues || pauseClicked || form.valid()) {

                        // Turn on the spinner for the clicked button (we don't have to ever turn if off b\c we get a brand new button back in the response)
                        // but don't do it right away, it looks annoying if the step is fast and it just flashes
                        setTimeout(function () {
                            if (!ajaxForbiddenError) {
                                clickedButton.js(jsSelectors.spin).css("visibility", "visible");
                            }
                        }, 100);

                        // the form value data to post (only when moving Next)
                        var formValues = [];
                        if (includeFormValues || pauseClicked) {
                            for (const [name, value] of new FormData(form[0])) {
                                formValues.push({ name, value });
                            }

                            if (pauseClicked) {
                                formValues.push({ name: "pausing", value: true })
                            };
                        }

                        // Navigate 
                        navigate(event, clickedButton.data("url"), formValues)
                            .fail(function (xhr) {
                                ajaxForbiddenError = xhr.status === 403;
                                clickedButton.js(jsSelectors.spin).css("visibility", "hidden");
                            });
                    }
                }
            });

            //
            // Ajax Navigation
            //
            function navigate(formSubmissionEvent, url, formValues) {

                // Post the navigation
                return $.post(
                    {
                        url: url,
                        headers: navigationToken,
                        data: formValues,
                        clearEventBanner: true
                    }
                ).done(function (_, __, jqXHR) {
                    handleResponse(jqXHR)
                }).fail(function (jqXHR) {
                    handleResponse(jqXHR)
                });

                // Handle the response fromt the wizard
                function handleResponse(jqXHR) {

                    // Success - response is the updated html snippet
                    if (jqXHR.status == 200) {

                        var content = $(jqXHR.responseText);

                        // There should be the wizard div, and some scripts.
                        var updatedWizardDiv = content.filter(wizardSelector);
                        var scripts = content.filter("script");

                        // clear any previous pause handler
                        _onPausingCallback = null;

                        // We leave the orignal wizardDiv - just update what is inside of it.  We also have to insert the scripts so they execute
                        if (updatedWizardDiv.exists()) {
                            wizardDiv.html(updatedWizardDiv.children().add(scripts));
                        }
                        // If the div doesn't exist, likely its some exception text to display
                        else {
                            wizardDiv.html(jqXHR.responseText);
                        }

                        // Always scroll the window back to the top. This makes sense after navigating, 
                        // as well as in the case of an error so that the error panel is in view.  
                        window.scrollTo(0, 0);
                    }

                    // 202 Accepted - what the wizard codes for wanting to redirect
                    else if (jqXHR.status == 202) {
                        window.location = jqXHR.getResponseHeader("location");
                    }

                    else if (jqXHR.status == 204) {
                        // no content, do nothing
                        formSubmission.onInvalidFormSubmit(formSubmissionEvent);
                    }

                    // Error
                    else {
                        console.log("Unknown failure during wizard step navigation:")
                        console.log(jqXHR);
                    }
                }
            }

        }

        //
        // Get the wizard's navigation token
        //
        function getNavigationToken() {
            return _navigationToken;
        }

        //
        // Callback which occurs when the wizard is paused
        // 
        function onPausing(onPausingCallback) {
            _onPausingCallback = onPausingCallback;
        }

        // Exported public API
        var exports = {
            initialize: initialize,
            getNavigationToken: getNavigationToken,
            onPausing: onPausing
        };

        return exports;
    }
);